import React, { useEffect, useState } from 'react';
import TextArea from 'antd/es/input/TextArea';
import { Button, Form, UploadFile } from 'antd';
import { EmailContent, EmailLanguage } from '../../../../../hooks/api/emails';
import EmailSupport from '../Static/Support';
import EmailFooter from '../Static/Footer';
import ImageUpload, { generateFileObjFromUrl } from '../../../../Common/Uploaders/ImageUpload';

import styles from './index.module.scss';

interface EmailTemplateProps {
  content: EmailContent
  lang: EmailLanguage
  handleChange: (key: keyof EmailContent, payload: string) => void
}

function EmailTemplate2({
  content, lang, handleChange,
}: EmailTemplateProps) {
  const [bannerFile, setBannerFile] = useState<UploadFile[]>([]);
  const [bannerFile2, setBannerFile2] = useState<UploadFile[]>([]);
  const [bannerFile3, setBannerFile3] = useState<UploadFile[]>([]);

  useEffect(() => {
    setBannerFile(content.banner?.length ? [generateFileObjFromUrl(content.banner)] : []);
    setBannerFile2(content.banner2?.length ? [generateFileObjFromUrl(content.banner2)] : []);
    setBannerFile3(content.banner3?.length ? [generateFileObjFromUrl(content.banner3)] : []);
  }, [lang]);

  useEffect(() => {
    handleChange('banner', (bannerFile[0]?.url || ''));
  }, [bannerFile]);

  useEffect(() => {
    handleChange('banner2', (bannerFile2[0]?.url || ''));
  }, [bannerFile2]);

  useEffect(() => {
    handleChange('banner3', (bannerFile3[0]?.url || ''));
  }, [bannerFile3]);

  return (
    <>
      <div className={styles.container}>
        <Form>
          <ImageUpload
            name="banner"
            setFileList={setBannerFile}
            cropperProps={{ aspect: 560 / 220 }}
            fileList={bannerFile}
            multiple={false}
            allowToPreview={false}
            label="Загрузить изображение 1120x440px"
            email
            H220
          />
          <div className={styles.content}>
            <div className={styles.label}>Заголовок</div>
            <TextArea
              rows={3}
              value={content.title}
              style={{ marginBottom: '24px' }}
              onChange={(e) => handleChange('title', e.target.value)}
            />
            <div className={styles.label}>Текстовый блок</div>
            <TextArea
              rows={7}
              value={content.content}
              onChange={(e) => handleChange('content', e.target.value)}
            />
          </div>
          <ImageUpload
            name="banner2"
            setFileList={setBannerFile2}
            cropperProps={{ aspect: 560 / 220 }}
            fileList={bannerFile2}
            multiple={false}
            allowToPreview={false}
            label="Загрузить изображение 1120x440px"
            email
            H220
          />
          <div className={styles.content}>
            <div className={styles.label}>Заголовок</div>
            <TextArea
              rows={3}
              value={content.title2}
              style={{ marginBottom: '24px' }}
              onChange={(e) => handleChange('title2', e.target.value)}
            />
            <div className={styles.label}>Текстовый блок</div>
            <TextArea
              rows={7}
              value={content.content2}
              onChange={(e) => handleChange('content2', e.target.value)}
            />
          </div>
          <Button className={styles.btn}>{lang === 'ru' ? 'Купить участие' : 'Купити участь'}</Button>
          <div className={styles.content}>
            <div className={styles.label}>Заголовок с цветным фоном</div>
            <TextArea
              rows={3}
              className={styles.orangeBg}
              value={content.title3}
              style={{ marginBottom: '24px' }}
              onChange={(e) => handleChange('title3', e.target.value)}
            />
            <div className={styles.label}>Текстовый блок с цветным фоном</div>
            <TextArea
              rows={7}
              className={styles.orangeBg}
              value={content.content3}
              onChange={(e) => handleChange('content3', e.target.value)}
            />
          </div>
          <ImageUpload
            name="banner3"
            setFileList={setBannerFile3}
            cropperProps={{ aspect: 560 / 140 }}
            fileList={bannerFile3}
            multiple={false}
            allowToPreview={false}
            email
            label="Загрузить изображение 1120x280px"
            H140
          />
          <EmailSupport lang={lang} />
        </Form>
      </div>
      <EmailFooter lang={lang} />
    </>
  );
}

export default EmailTemplate2;
